import { camelcaseKeys } from '@shared-runtime/utils/keys';

import type { ActivateCurrencyResult } from './apiSchema';
import type { ActivateCurrencyResponse } from './schema';

export function normalizeActivateCurrency(
  data: ActivateCurrencyResult,
): ActivateCurrencyResponse {
  return camelcaseKeys(data, { deep: true }) as ActivateCurrencyResponse;
}
